import * as React from 'react';
import Image from 'next/image';
import clsx from 'clsx';

import styles from './PinCard.module.css';
import { getImageUrl } from 'lib/util/imageUrl';
import { AnimatedButton } from 'components/Map/AnimatedButton';
import { DigitalMapPin } from 'models/digitalMap';
import { smoothMoveCamera } from 'components/Map/mapUtils';
import { useUrlQueryDisplayState } from 'components/Map/useUrlQueryDisplayState';
import MapDisplayContextService from 'components/Map/MapDisplayContextService';

interface Props {
  pin: DigitalMapPin;
  onCloseChat: () => void;
  isSingle: boolean;
  isDoubleWide: boolean;
}

export const PinCard = ({ pin, onCloseChat, isSingle, isDoubleWide }: Props) => {
  const { pushUrlParams } = useUrlQueryDisplayState();

  const imageUrl = pin.media_items.find((item) => item.type === 'IMAGE')?.url || '';

  const handleShowOnMap = (e: React.MouseEvent) => {
    e.preventDefault();
    pushUrlParams({ pin: pin.key, pind: 'SUMMARY', nav: 'map' });
    onCloseChat();

    smoothMoveCamera(
      MapDisplayContextService.getMapDisplayContext()?.googleMap ?? null,
      MapDisplayContextService.getMapDisplayContext()?.openLayersMap ?? null,
      {
        center: {
          lat: pin?.location?.latitude ?? 0,
          lng: pin?.location?.longitude ?? 0,
        },
      }
    );
  };

  return (
    <>
      <section
        className={clsx(
          styles['product-card'],
          isSingle && styles['full-width'],
          isDoubleWide && styles['half-width']
        )}
      >
        {imageUrl ? (
          <Image
            priority
            alt=""
            width={200}
            height={148}
            className={styles['product-image']}
            key={imageUrl}
            src={imageUrl}
            loader={({ width, src }) => getImageUrl(src, width * 1.5)}
          />
        ) : (
          <div className={styles['placeholder-container']}>
            <img
              src="/static/images/map/map_pin_blue.svg"
              alt=""
              className={styles['placeholder-icon']}
            />
          </div>
        )}
        <div className={styles['product-content']}>
          <div className={styles['product-content-left']}>
            <h3 className={styles['product-title']}>{pin.title}</h3>
            {pin.description && <p className={styles['product-description']}>{pin.description}</p>}
          </div>
          <AnimatedButton
            className={styles['product-button']}
            clickedClassName={styles['clicked']}
            onClick={handleShowOnMap}
          >
            <img src="/static/images/map/map_pin_blue.svg" alt="" />
          </AnimatedButton>
        </div>
      </section>
    </>
  );
};
